import React from 'react';
import { connectStateResults, Hits } from 'react-instantsearch-dom';
import HeaderSearchResult from './HeaderSearchResult';
import HeaderSearchNoResult from './HeaderSearchNoResult';

const HeaderSearchHits = ({ searchState }) => {
    if (!searchState.query) {
        return null;
    }
    return (
        <div
            className="header-search-hits"
        >
            <Hits hitComponent={HeaderSearchResult} />

            <HeaderSearchNoResult />
        </div>
    );
};

export default connectStateResults(HeaderSearchHits);
